import Parameter from "./parameter";
import ISortOrder from "../interface/sort-order";
import ParamStorage from "../enum/param-storage";
import ParameterStorage from "../class/parameter-storage";

class SortOrdersSingleton {

    public get(param: ParamStorage, entityId: number | null = null): number[] {
        const sortOrder: ISortOrder | undefined = this.getStore().getAll().find((o: ISortOrder) => {
            return o.param === param && o.entityId === entityId;
        });
        return sortOrder ? sortOrder.order : [];
    }

    public async set(sortOrder: ISortOrder): Promise<ISortOrder> {
        const result: ISortOrder | undefined = this.getStore().getAll().find((o: ISortOrder) => {
            return o.param === sortOrder.param && o.entityId === sortOrder.entityId;
        });
        if (result) {
            result.order = sortOrder.order;
            return this.getStore().update(result);
        } else {
            return this.getStore().create(sortOrder);
        }
    }

    /* Private Methods - Parameter Storage */

    private getStore(): ParameterStorage<ISortOrder> {
        return Parameter.get(ParamStorage.SortOrders);
    }

}

const SortOrders = new SortOrdersSingleton();

export default SortOrders;